import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUserStore } from '../../shared/store/userStore'
import { useCompanyStore } from '../../shared/store/companyStore'
import { useOnboardingStore } from '../../shared/store/onboardingStore'
import { LoginApi } from '../login/LoginApi'

export const SignoutContainer = () => {
    const userSignOut = useUserStore(state => state.userSignOut)
    const resetCompanySettings = useCompanyStore(state => state.resetCompanySettings)
    const resetOnboardingState = useOnboardingStore(state => state.reset)

    const navigate = useNavigate()

    useEffect(() => {
        const performLogout = async () => {
            try {
                await LoginApi.logout()
            } catch (error) {
                console.error('Logout API error:', error)
            } finally {
                userSignOut()
                resetCompanySettings()
                resetOnboardingState()
                navigate('/login')
            }
        }

        performLogout()
    }, [])

    return null
}
